export default "__VITE_ASSET__66296e92__"